import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

export const portfolioApi = {
  create: (data) => api.post('/portfolios', data),
  getMy: () => api.get('/portfolios/my'),
  update: (data) => api.put('/portfolios/my', data),
  browse: (skip = 0, limit = 10) => api.get(`/portfolios/browse?skip=${skip}&limit=${limit}`),
  getById: (id) => api.get(`/portfolios/${id}`),
  getPublic: (id) => api.get(`/portfolios/public/${id}`),
  addProject: (data) => api.post('/portfolios/my/projects', data),
  saveBuilderResponses: (responses) => api.post('/portfolios/my/builder', responses),
  search: (skip = 0, limit = 500) => api.get(`/portfolios/search?skip=${skip}&limit=${limit}`),
};

export const likesApi = {
  like: (portfolio_id, action) => api.post('/likes', { portfolio_id, action }),
  getMatches: () => api.get('/matches'),
};

export const notificationsApi = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.put(`/notifications/${id}/read`),
};

export const analyticsApi = {
  getStats: () => api.get('/analytics'),
};

export default api;